import { Box, CircularProgress } from '@mui/material';
import React from 'react';
import Investor from '../../models/Investor';
import { StyledButton } from '../styles/StyledButtons';
import { EOIConfirmCheckbox } from './EOIFormControls';
import { EOIIntroText, EOITitle } from './EOISettingsContext';
import { SuggestedEOISummary } from './SuggestedEOISummary';

export const EOISectionInvestorSuggestedPanel: React.FC<{
  investor: Investor;
  confirmed: boolean;
  accepting: boolean;
  rejecting: boolean;
  setConfirmed: (value: boolean) => void;
  handleAcceptSuggestedEOI: () => void;
  handleRejectSuggestedEOI: () => void;
}> = ({
  investor,
  confirmed,
  accepting,
  rejecting,
  setConfirmed,
  handleAcceptSuggestedEOI,
  handleRejectSuggestedEOI,
}) => (
  <>
    <EOITitle />
    <EOIIntroText />
    <SuggestedEOISummary investor={investor} perspective="investor" />
    <EOIConfirmCheckbox confirmed={confirmed} onChange={setConfirmed} />
    <Box className="eoiButtons two-buttons" mt={2} display="flex" gap={2}>
      <StyledButton
        disabled={!confirmed || accepting || rejecting}
        onClick={handleAcceptSuggestedEOI}
      >
        {accepting && <CircularProgress size={16} sx={{ marginRight: 1, color: 'inherit' }} />}
        Accept and Submit
      </StyledButton>
      <StyledButton
        buttonVariant="inactiveOrCancel"
        className="destructive"
        disabled={accepting || rejecting}
        onClick={handleRejectSuggestedEOI}
      >
        {rejecting && <CircularProgress size={16} sx={{ marginRight: 1, color: 'inherit' }} />}
        Reject
      </StyledButton>
    </Box>
  </>
);

export const EOISectionDecisionMakerSuggestedPanel: React.FC<{
  investor: Investor;
  confirmed: boolean;
  accepting: boolean;
  rejecting: boolean;
  setConfirmed: (value: boolean) => void;
  handleAcceptSuggestedEOI: () => void;
  handleRejectSuggestedEOI: () => void;
}> = ({
  investor,
  confirmed,
  accepting,
  rejecting,
  setConfirmed,
  handleAcceptSuggestedEOI,
  handleRejectSuggestedEOI,
}) => (
  <>
    <EOITitle />
    <EOIIntroText />
    <SuggestedEOISummary investor={investor} perspective="decision-maker" />
    <EOIConfirmCheckbox confirmed={confirmed} onChange={setConfirmed} />
    <Box className="eoiButtons two-buttons" mt={2} display="flex" gap={2}>
      <StyledButton
        disabled={!confirmed || accepting || rejecting}
        onClick={handleAcceptSuggestedEOI}
      >
        {accepting && <CircularProgress size={16} sx={{ marginRight: 1, color: 'inherit' }} />}
        Accept and Submit
      </StyledButton>
      <StyledButton
        buttonVariant="inactiveOrCancel"
        className="destructive"
        disabled={accepting || rejecting}
        onClick={handleRejectSuggestedEOI}
      >
        {rejecting && <CircularProgress size={16} sx={{ marginRight: 1, color: 'inherit' }} />}
        Reject
      </StyledButton>
    </Box>
  </>
);
